<template>
  <div id="container"  class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->

 
  <iframe src="3dmap/index1.html" style="width:100%;height:100%;border: none;"></iframe>
  <!-- 顶部 -->
  <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq"></div>
          <div class="dh_wz_tb"></div>
          <div class="dh_wz_wz">高标准农田</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">项目总览</div></router-link>
          <router-link :to="{path:'/plant'}"><div class="dh_lb_bt">高标准农田</div></router-link>
           <!-- <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt">项目进度</div></router-link> -->
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt dh_lb_bt_cur">病虫害管理</div></router-link>
          <!-- <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link> -->
          <!-- <router-link :to="{path:'/suyuan'}"><div class="dh_lb_bt">农业溯源</div></router-link> -->
          <!-- <router-link :to="{path:'/qihouYj'}"><div class="dh_lb_bt">气候灾害预警</div></router-link> -->
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"><img src="../assets/img/gbzntyj/sy.png" class="return" /></router-link>
          <img  src="../assets/img/gbzntyj/fh.png"  class="return"  @click="clickReturn"  />
        </div>
  </div>
  <!-- 左边 -->
  <div class="left">
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />病虫害总况</div>
  <div class="borderBox leftBox1">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" id="tabs">
      <el-tab-pane v-for="(item,index) in leftData1" :key="index"  :label="item.name" :name="index">
        <div class="leftCon animate__animated animate__fadeInLeft" >
          <div class="leftDataTop">
              <img :src="item.img" />
              <div class="leftDataTopRight">
                <h4>{{item.name}}</h4>
                <p v-html="item.info"></p>
              </div>
            </div>
            <div class="leftDataBottom">
              <h4>[ 防治方法 ]</h4>
              <p class="leftContent" v-html="item.fangzhi"></p>  
            </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <div class="borderBox leftBox2">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <leftBar1 :leftData1="leftData1[curLeftIndex].data" v-if="showDiv" />
  </div>
</div>
<!-- 右侧 -->
<div class="right">
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />每日虫情检测</div>
  <div class="borderBox rightBox1">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <div class="imgItem" v-for="(item,index) in rightData1" :key="index">
      <div class="imgItemBg"><img :src="item.img" /></div><p>{{item.date}}</p></div>
  </div>
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />杀虫灯情况</div>
  <div class="borderBox rightBox2">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <div class="subTit"> <span>杀虫灯编号</span><span>累计杀虫</span><span>设备状态</span> </div>
    <div class="rightContent2"><dv-scroll-board :config="config" style="width:100%;height:100%" /></div>
  </div>
</div>
 </div>
 <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";


import leftBar1 from "@/components/binghai/leftBar1.vue";
import footer1 from "../components/footer.vue";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const activeName = ref(0)
    const state = reactive({
      leftData1:[
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"1俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:[
            {"mc":"3.1","dysl":"70","sysl":"89",yc:"20"},
            {"mc":"3.2","dysl":"75","sysl":"107",yc:"70"},
            {"mc":"3.3","dysl":"40","sysl":"61",yc:"60"},
            {"mc":"3.4","dysl":"70","sysl":"90",yc:"58"},
            {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
            {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
          ]
        },
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"2俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:[
            {"mc":"3.1","dysl":"80","sysl":"89",yc:"20"},
            {"mc":"3.2","dysl":"75","sysl":"107",yc:"70"},
            {"mc":"3.3","dysl":"40","sysl":"61",yc:"60"},
            {"mc":"3.4","dysl":"70","sysl":"90",yc:"58"},
            {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
            {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
          ]
        },
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:[
            {"mc":"3.1","dysl":"50","sysl":"89",yc:"20"},
            {"mc":"3.2","dysl":"75","sysl":"107",yc:"70"},
            {"mc":"3.3","dysl":"40","sysl":"61",yc:"60"},
            {"mc":"3.4","dysl":"70","sysl":"90",yc:"58"},
            {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
            {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
          ]
        },
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"3俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:[
            {"mc":"3.1","dysl":"80","sysl":"89",yc:"20"},
            {"mc":"3.2","dysl":"15","sysl":"107",yc:"70"},
            {"mc":"3.3","dysl":"40","sysl":"61",yc:"60"},
            {"mc":"3.4","dysl":"70","sysl":"90",yc:"58"},
            {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
            {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
          ]
        },
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
        info:"俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
        fangzhi:"(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
        data:[
          {"mc":"3.1","dysl":"80","sysl":"89",yc:"20"},
          {"mc":"3.2","dysl":"75","sysl":"107",yc:"70"},
          {"mc":"3.3","dysl":"40","sysl":"61",yc:"60"},
          {"mc":"3.4","dysl":"90","sysl":"90",yc:"58"},
          {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
          {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
        ]
        },
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
        info:"俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
        fangzhi:"(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
        data:[
          {"mc":"3.1","dysl":"80","sysl":"89",yc:"20"},
          {"mc":"3.2","dysl":"75","sysl":"107",yc:"70"},
          {"mc":"3.3","dysl":"50","sysl":"61",yc:"60"},
          {"mc":"3.4","dysl":"70","sysl":"90",yc:"58"},
          {"mc":"3.5","dysl":"43","sysl":"71",yc:"49"},
          {"mc":"3.6","dysl":"56","sysl":"100",yc:"26"},
        ]
        },
      ],
      curLeftIndex:0,
      showDiv:true,
      rightData1:[
        {date:"2024.3.1",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")},
        {date:"2024.3.2",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")},
        {date:"2024.3.3",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")},
        {date:"2024.3.4",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")},
        {date:"2024.3.5",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")},
        {date:"2024.3.6",img:require("@/assets/img/gbzntyj/bingchong/img2.jpg")}
      ],
      config: {
        // header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ["1号杀虫灯", "12", "在线"],
          ["1号杀虫灯", "17", "88人"],
          ["1号杀虫灯", "15", "88人"],
          ["1号杀虫灯", "22", "88人"],
          ["1号杀虫灯", "16", "88人"],
          ["1号杀虫灯", "14", "88人"],
          ["1号杀虫灯", "5", "88人"],
          ["1号杀虫灯", "2", "88人"],
          ["1号杀虫灯", "7", "88人"],
        ],
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        // columnWidth: [150],
        align: ["center"],
        // rowNum:6
      },
    });



    // 在 onMounted 中初始化地图
    onMounted(() => {

    });


    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }


    function handleClick (tab,e){
      // console.log(tab.index)
      
      state.showDiv = false; // 点击后先隐藏div
      state.curLeftIndex = tab.index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onUnmounted(() => {
     
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      mapRef,
      clickReturn,
      activeName,
      handleClick
    };
  },
  components: {
    footer1,
    leftBar1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
// /* 隐藏水平滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__horizontal {
//   display: none!important;
// }
 
// /* 隐藏垂直滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__vertical {
//   display: none;
// }


.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }
}


  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .topContent {
    width: 100%;
    height: 100px;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 34, 25, 1) 20%,
      rgba(0, 34, 25, 0)
    );
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 26%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
  // .content{
  //   width: 100%;
    
  //   display: flex;
  //   justify-content: space-between;
  //   padding: 0 24px;
  //   box-sizing: border-box;
  //   z-index: 999;
  //   }
.left,.right{
  width: 572px;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  padding-top: 80px;
  box-sizing: border-box;
}
.title{
  background: url("../assets/img/gbzntyj/bingchong/btk.png") no-repeat;
  width: 557px;
  height: 45px;
  line-height: 45px;
  padding-left: 10px;
  font-size: 18px;
  color: #fff;
  text-align: left;
  display: flex;
  .titIcon{
    display: block;
    width: 12px;
    height: 12px;
    margin-top: 16px;
    margin-right: 10px;
    animation: titIcon 5s linear infinite;
  }
  
}
.borderBox{
  border: 1px solid #165752;
  box-shadow: inset 0 0 20px 16px rgba(26, 91,85,.5);
  padding: 20px;
  box-sizing: border-box;
  background: rgba(0,0,0,.15);
  position: relative;
  overflow: hidden;
}
.left{
  left: 0;
  padding-left: 24px;
  background:url("../assets/img/gbzntyj/gaungai/zjb.png") no-repeat ;
  .leftBox1{
    width:100%;
    height:480px;
    margin: 10px 0;
    .leftTit{
      display: flex;
      overflow-x: auto;
      scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
      width: 100%;
      height: 36px;
      font-size: 16px;
      color: #fff; 
    }
    .leftCon{
      width: 100%;
      flex: 1;
    }
    .leftDataTop{
      display: flex;
      height: 93px;
      margin: 10px 0 10px;
      img{
        width: 109px;
        height: 93px;
        margin: 0 20px 0 10px;
      }
      .leftDataTopRight{
        flex: 1;
        height: 100%;
        overflow: hidden;
        text-align: left;
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        margin-right: 20px;
        justify-content: space-between;
        h4{
          flex: 1;
          margin: 0 0 8px;
        }
        p{
          height: 60px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
     }
     .leftDataBottom{
      text-align: left;
      color: #fff;
      line-height: 24px;
      padding: 0 16px;
      font-size: 14px;
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      h4{
        height: 36px;
        line-height: 36px;
      }
      .leftContent{
        width: 100%;
        height: 240px;
        scrollbar-width: none;
        -ms-overflow-style: none;
        overflow-x: hidden;
        overflow-y: auto;
      }
     }
  }
  .leftBox2{
    flex: 1;
  }
}
.right{
  right: 0;
  background:url("../assets/img/gbzntyj/gaungai/yjb.png") no-repeat ;
  padding-right: 24px;
  .rightBox1{
    width: 100%;
    height: 360px;
    margin: 10px 0 30px;
    padding: 20px 30px 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .imgItem{
      margin: 0 10px;
      width: 127px;
      height: 138px;
      .imgItemBg{
        width:127px ;
        height: 112px;
        background: url("../assets/img/gbzntyj/bingchong/imgBg.png") no-repeat ;
        padding: 5px;
        box-sizing: border-box;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      p{
          color: #fff;
          font-size: 14px;
          line-height: 24px;
        }
    }
    
  }
  .rightBox2{
    width: 100%;
    flex: 1;
    margin: 10px 0 0;
    display: flex;
    flex-direction: column;
    .subTit{
      width: 100%;
      height: 37px;
      background: linear-gradient(to right, rgba(32, 156, 256, 0),rgba(32, 156, 256, 0.1), rgba(104, 224, 207, 0.2), rgba(0, 135, 240, 0.1), rgba(0, 135, 240, 0));
      font-size: 16px;
      line-height: 37px;
      color: #fff;
      display: flex;
      span{
        display: block;
        flex: 1;
      }
    }
    .rightContent2{
      width: 100%;
      flex: 1;
    }
  }
}
    
 ::v-deep .row-item{
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(255,255,255,0.05)10%,rgba(255,255,255,0.2),rgba(255,255,255,0.05))1;
}
  // 左侧1 tab


 ::v-deep .el-tabs__item{
  width: 104px;
  height: 36px;
  padding: 0;
  border: 1px solid #1A6266;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
}
::v-deep  .el-tabs__item::before,::v-deep .el-tabs__item::after{
    content: " ";
    background: #21FCFF;
    width: 2px;
    height: 12px;
    position: absolute;
    top: 12px;
}
::v-deep .el-tabs__item::before{left:-1px}
::v-deep .el-tabs__item::after{right:-1px}
::v-deep .el-tabs__nav{ display: flex;}
::v-deep .el-tabs__nav-wrap::after{display: none;}
::v-deep .el-tabs__active-bar{width: 100%;background-color:#21FCFF;}
::v-deep .is-active{ color: #A1C81F;}


@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}
.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 0px;
  left: 0;
  width: 10%;
  height: 1px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 1px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: -1px;
  right: -100%;
  width: 20%;
  height: 1px;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 0px;
  width: 1px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
